<template>
  <main class="not-found">
    <div class="container">
      <h1>404</h1>
      <h2>Nie znaleziono strony</h2>
      <p>Adres, który wpisano, nie istnieje.</p>
      <router-link :to="{ name: 'Home' }" class="btn">Wróć na stronę główną</router-link>
    </div>
  </main>
</template>

<script>
export default {
  name: 'NotFoundPage'
}
</script>

<style lang="scss" scoped>
.not-found {
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #f8f9fa;

  h1 {
    font-size: 4rem;
    color: #FF6B35;
    margin-bottom: 10px;
  }

  h2 {
    font-size: 2rem;
    color: #333;
    margin-bottom: 15px;
  }

  p {
    color: #666;
    margin-bottom: 30px;
  }
}
</style>
